import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'goal',
  template: require('./goal.component.html')
})
export class GoalComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.currentGoal = this.appActions.getData('goalSession.goal', null);
  }

  updateOptionValue(event) {
    if (event.value) {
      if (event.value === 'retirement') {
        this.appActions.deleteData('goalSession.accountTaxType');
      } else {
        this.appActions.setData('goalSession.accountTaxType', 'taxable');
      }
    }
  }
}
